import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
// import Vuex from 'vuex'
import App from './App'
import router from './router'
import animate from 'animate.css';
// import store from "./store";
// Vue.use(Vuex)
Vue.use(VueResource);
Vue.config.productionTip = false

// const store = new Vuex.Store({
//   state: {
//     count: 0
//   },
//   mutations: {
//     increment (state) {
//       state.count++
//     }
//   }
// })
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    // store,
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js